module.exports = __webpack_public_path__ + "img/1383.058e5090.jpg";